import script from "./goRinSyo0073.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0073.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0073.vue?vue&type=style&index=0&id=c15561c0&lang=scss"

const __exports__ = script;

export default __exports__